<div class="text-center content">
  <h1 class="text-red-600">FI not LIVE in the system</h1>
  <h2 class="text-red-600">
    Your institution is currently not Live. Please check back once your institution is Live.
  </h2>
</div>
